import type { OrderItem, PaymentMethod } from '../types';
import type { ReceiptData } from '@/services/hardware.service';
import type { StoreSettings } from '@/services/store.service';

/** Snapshot dữ liệu đơn tại thời điểm thanh toán thành công — độc lập với POS tab. */
export interface CheckoutSuccessResult {
  orderCode: string;
  dateISO: string;
  total: number;
  paymentMethod: PaymentMethod;
  cashReceived?: number;
  change?: number;
  customerName?: string;
  items: OrderItem[];
}

type StoreInfo = Pick<StoreSettings, 'name' | 'address' | 'district' | 'city' | 'phone' | 'receiptFooter'>;

const PAYMENT_LABEL: Record<PaymentMethod, string> = {
  cash: 'Tiền mặt',
  bank: 'CK',
  wallet: 'Ví ĐT',
  card: 'Thẻ TD',
};

/** Map snapshot + thông tin cửa hàng + tên thu ngân → ReceiptData để in nhiệt. */
export function buildReceiptData(
  result: CheckoutSuccessResult,
  store: StoreInfo | undefined,
  cashierName: string,
): ReceiptData {
  const subtotal = result.items.reduce((s, i) => s + i.price * i.quantity, 0);
  const discount = result.items.reduce((s, i) => s + i.discountAmount, 0);
  const storeAddress = [store?.address, store?.district, store?.city].filter(Boolean).join(', ') || undefined;

  return {
    storeName: store?.name ?? '',
    storeAddress,
    storePhone: store?.phone,
    orderCode: result.orderCode,
    items: result.items.map((i) => ({
      name: i.variantName,
      sku: i.variantCode,
      qty: i.quantity,
      price: i.price,
      discount: i.discountAmount || undefined,
    })),
    subtotal,
    discount,
    total: result.total,
    paymentMethod: PAYMENT_LABEL[result.paymentMethod],
    amountPaid: result.cashReceived,
    change: result.change,
    cashier: cashierName,
    date: result.dateISO,
    footer: store?.receiptFooter,
  };
}
